<template>
  <div
    class="background"
    :class="{
      '--grayed': color === 'grayed',
      ['background--' + game]: true,
      'background--ddu': platform === 'steam' || platform === 'galaxy',
    }"
  >
    <div class="background__img"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Background",
  props: {
    color: {
      type: String,
    },
    game: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      platform: (state) => state.initPlatform,
    }),
    backgroundClass() {
      return `background--${this.game}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background: #3b4553;
  background-color: #1c1715;
  z-index: -1;

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60%;
    opacity: 0.65;
    background-image: linear-gradient(
      0deg,
      rgb(0, 0, 0) 0%,
      rgba(0, 0, 0, 0) 100%
    );
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    bottom: 0;
    opacity: 0;
    transition: opacity 0.4s;
    border-radius: 5px;
    background-image: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.5) 18%,
      rgb(0, 0, 0) 50%,
      rgba(0, 0, 0, 0.5) 83%,
      rgba(0, 0, 0, 0) 100%
    );
    pointer-events: none;
  }

  &--bg3 {
    // background-color: $purple;
    background-color: #1c1715;

    & .background__img {
      background-image: url("~@/assets/img/png/main-bg3.png");
    }
  }

  // &--ddu {
  //   & .background__img {
  //     background-image: url("~@/assets/img/png/main-dde.png");
  //   }
  // }

  &--dos2 .background__img {
    background-image: url("~@/assets/img/png/main-dos2.png");
  }

  &--dos .background__img {
    background-image: url("~@/assets/img/png/main-dos.png");
  }

  &--onboarding .background__img,
  &--onboarding-bg3 .background__img {
    background-image: url("~@/assets/img/png/main.png");
  }

  &--onboarding-dos2 .background__img {
    background-image: url("~@/assets/img/png/main-onboarding-dos2.png");
  }

  &--onboarding-dos .background__img {
    background-image: url("~@/assets/img/png/main-onboarding-dos.png");
  }

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-repeat: no-repeat;
    background-position: 30% top;
    background-size: cover;
    // max-width: 1180px;
  }

  &__logo {
    width: 57.636364vw;
    // width: 500px;
    height: auto;
    position: absolute;
    top: 21.454546vw;
    // top: 200px;
    left: 50%;
    transform: translateX(-50%);
    transition: opacity 0.4s, visibility 0.4s;
  }

  &.--grayed {
    &::after {
      opacity: 0.8;
    }

    .background__img {
      filter: grayscale(1);
    }

    .background__img--small {
      filter: grayscale(1);
    }

    .background__logo {
      opacity: 0;
      visibility: hidden;
    }
  }
}

@media screen and (min-width: 970px) {
  .background {
    &__img {
      display: block;

      &--small {
        display: none;
      }
    }

    &__logo {
      width: 33.636364vw;
      height: auto;
      position: absolute;
      top: 10.4545455vw;
      left: 50%;
      transform: translateX(-50%);
      transition: opacity 0.4s, visibility 0.4s;
    }
  }
}

@media screen and (min-width: 1280px) {
  .background {
    &__img {
      background-size: cover;
    }
  }
}

@media screen and (min-width: 1400px) {
  .background {
    &__img {
      width: 100%;
    }
  }
}

@media screen and (min-width: 1921px) {
  .background {
    &__logo {
      // width: 645px;
      width: 65vh;
      height: auto;
      position: absolute;
      top: 20vh;
      left: 50%;
      transform: translateX(-50%);
      transition: opacity 0.4s, visibility 0.4s;
    }
  }
}
</style>
